import Auth from '@/helpers/authorizations'
import ManagementLayout from '@/layouts/Management'

const usersRouter = {
  path: '/users',
  component: ManagementLayout,
  redirect: '/users/list',
  children: [
    {
      path: 'list',
      component: () => import('@/views/users/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listUsers
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/users/ListTable'),
          meta: {
            auth: Auth.listUsers,
            tabName: 'all'
          }
        }
      ]
    },
    {
      path: ':id',
      component: () => import('@/views/users/DetailLayout'),
      redirect: ':id/detail',
      meta: {
        auth: Auth.showUser
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/users/details/Detail'),
          meta: {
            auth: Auth.showUser,
            tabName: 'detail'
          }
        },
        {
          path: 'orders',
          component: () => import('@/views/users/details/Orders'),
          meta: {
            auth: Auth.showUser,
            tabName: 'orders'
          }
        },
        {
          path: 'order_statistics',
          component: () => import('@/views/users/details/OrderStatistics'),
          meta: {
            auth: Auth.showUser,
            tabName: 'order_statistics'
          }
        },
        {
          path: 'top_ups',
          component: () => import('@/views/users/details/TopUps'),
          meta: {
            auth: Auth.showUser,
            tabName: 'top_ups'
          }
        },
        {
          path: 'setting',
          component: () => import('@/views/users/details/Setting'),
          redirect: 'setting/point_records',
          meta: {
            auth: Auth.showUser,
            tabName: 'setting'
          },
          children: [
            {
              path: 'point_records',
              component: () => import('@/views/users/details/setting/UserPointRecords'),
              meta: {
                auth: Auth.showUser,
                tabName: 'setting'
              }
            }
          ]
        },
        {
          path: 'operation',
          component: () => import('@/views/users/details/Operation'),
          meta: {
            auth: Auth.showUser,
            tabName: 'operation'
          }
        },
        {
          path: 'transaction_records',
          component: () => import('@/views/users/details/TransactionRecords'),
          meta: {
            auth: Auth.showUser,
            tabName: 'transaction_records'
          }
        },
        {
          path: 'withdraw_application',
          component: () => import('@/views/users/details/WithdrawApplication'),
          meta: {
            auth: Auth.showUser,
            tabName: 'withdraw_application'
          }
        },
        {
          path: 'discounts',
          component: () => import('@/views/users/details/Discounts'),
          redirect: 'discounts/charging_packages',
          meta: {
            auth: Auth.showUser,
            tabName: 'discounts'
          },
          children: [
            {
              path: 'charging_packages',
              component: () => import('@/views/users/details/discounts/UserChargingPackages'),
              meta: {
                auth: Auth.showUser,
                tabName: 'discounts'
              }
            },
            {
              path: 'charging_cards',
              component: () => import('@/views/users/details/discounts/UserChargingCards'),
              meta: {
                auth: Auth.showUser,
                tabName: 'discounts'
              }
            },
            {
              path: 'coupons',
              component: () => import('@/views/users/details/discounts/UserCoupons'),
              meta: {
                auth: Auth.showUser,
                tabName: 'discounts'
              }
            },
            {
              path: 'groups',
              component: () => import('@/views/users/details/discounts/Groups'),
              meta: {
                auth: Auth.showUser,
                tabName: 'discounts'
              }
            }
          ]
        },
        {
          path: 'activity_info',
          component: () => import('@/views/users/details/ActivityInfo'),
          redirect: 'activity_info/trigger_outcomes',
          meta: {
            auth: Auth.showUser,
            tabName: 'activity_info'
          },
          children: [
            {
              path: 'trigger_outcomes',
              component: () => import('@/views/users/details/activity_info/UserTriggerOutcomes'),
              meta: {
                auth: Auth.showUser,
                tabName: 'activity_info'
              }
            },
            {
              path: 'activity_participations',
              component: () => import('@/views/users/details/activity_info/UserActivityParticipations'),
              meta: {
                auth: Auth.showUser,
                tabName: 'activity_info'
              }
            },
            {
              path: 'product_orders',
              component: () => import('@/views/users/details/activity_info/UserProductOrders'),
              meta: {
                auth: Auth.showUser,
                tabName: 'activity_info'
              }
            },
            {
              path: 'station_activities',
              component: () => import('@/views/users/details/activity_info/UserStationActivities'),
              meta: {
                auth: Auth.showUser,
                tabName: 'activity_info'
              }
            },
            {
              path: 'feedbacks',
              component: () => import('@/views/users/details/activity_info/Feedbacks'),
              meta: {
                auth: Auth.showUser,
                tabName: 'activity_info'
              }
            }
          ]
        }
      ]
    },
    {
      path: ':id/edit',
      component: () => import('@/views/users/Edit.vue'),
      meta: {
        auth: Auth.updateUser
      }
    }
  ]
}
export default usersRouter
